import { styled } from '@mui/system';
import { Divider as MuiDivider } from '@mui/material';

export const Divider = styled(MuiDivider)(({ theme }) => {
  const palette = theme.newPalette;
  return {
    backgroundColor: palette.divider,
  };
});
